import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { StyledTypography, ColoredCircularProgress } from 'styles/common';

import { sendUpdateProfileImageEvent } from 'constants/mixpanelHelper';

import { showErrorSnackbar } from 'services/snackbar';

import { Typography1, Typography2 } from 'uiToolkit/Typography';

import ImageUpload from './ImageUpload';
import { StyledAvatar } from './avatars';

const fileNameRegex = new RegExp('^[A-Za-z0-9_. -]+$');

export function ProfileCard({ employee, className }) {
  return (
    <StyledPaper className={className}>
      <CenterAlign>
        <StyledAvatar boxShadow={3} size="big2" alt="Profile Image" src={employee.getProfileImage()} topGutter={4} />
      </CenterAlign>
      <Typography1 topGutter={3}>{employee.fullName}</Typography1>
      <Typography2 topGutter={2} bottomGutter={3}>
        {employee.designation}
      </Typography2>
    </StyledPaper>
  );
}

function ProfileCardWithUploadSupport({ employee, onUpload, onUploadSuccess, onError, className, history }) {
  const [uploading, setUploading] = useState(false);
  const dispatch = useDispatch();
  const pattern = /image\/(gif|jpe?g|tiff|png|webp|bmp)$/i;
  function uploadImage(file) {
    if (!pattern.test(file.type)) {
      dispatch(showErrorSnackbar('Please upload an image file'));
      return;
    }
    if (file.size > 10 * 1000 * 1000) {
      const error = 'Image size cannot be more than 10 mb.';
      dispatch(showErrorSnackbar(error));
      return false;
    }
    // if (!fileNameRegex.test(file.name)) {
    //   dispatch(
    //     showErrorSnackbar(
    //       'Invalid file name, only allowed characters are alphabets, digits, hyphen, underscore, dot, and space'
    //     )
    //   );
    //   return;
    // }
    setUploading(true);
    onUpload(file)
      .then((res) => {
        sendUpdateProfileImageEvent();
        onUploadSuccess(res);
      })
      .catch((err) => {
        if (onError) onError(err);
      })
      .finally(() => setUploading(false));
  }

  // const goToProfilePage = () => {
  //   history.push(getProfileRoute(employee.id));
  // };
  return (
    <StyledPaper className={className}>
      <CenterAlign>
        <StyledAvatar boxShadow={3} size="big2" alt="Profile Image" src={employee.getProfileImage()} topGutter={4} />
        <UploadContainer uploading={uploading}>
          <UploadUI uploading={uploading}>
            {uploading ? (
              <ColoredCircularProgress color="white" size="tinier" />
            ) : (
              <ImageUpload setFile={uploadImage} icon={<StyledTypography align="center">Update</StyledTypography>} />
            )}
          </UploadUI>
        </UploadContainer>
      </CenterAlign>
      <Typography1 topGutter={3}>{employee.fullName}</Typography1>
      <Typography2 topGutter={2} bottomGutter={3}>
        {employee.designation}
      </Typography2>
    </StyledPaper>
  );
}

const StyledPaper = styled.div`
  text-align: center;
  // min-height: 30vh;
  ${'' /* margin: 4px; */}
  padding: ${(props) => props.theme.space.vertical.large}
    ${(props) => props.theme.space.horizontal.normal} !important;
`;

// const CenteredText = styled(StyledTypography)`
//   display: block;
//   text-align: center;
//   ${props => {
//     return (
//       props.topGutter &&
//       css`
//         margin-top: ${props => props.theme.spacing(1)}rem;
//       `
//     );
//   }}
// `;

const CenterAlign = styled.div`
  display: inline-block;
  margin: 0 auto;
  // justify-content: center;
  position: relative;
  height: 100%;
`;

const UploadContainer = styled.div`
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  border-radius: 50%;
  overflow: hidden;
  ${(props) =>
    props.uploading &&
    css`
      background: #0000008a;
    `};
`;
const UploadUI = styled.div`
  display: inline-flex;
  visibility: ${(props) => (props.uploading ? 'visible' : 'hidden')};
  background: #0000008a;
  height: 40%;
  color: white;
  width: 120px;
  border-bottom-left-radius: 80%;
  border-bottom-right-radius: 80%;
  transition: visibility 0.5s ease-in-out;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  ${UploadContainer}:hover & {
    visibility: visible;
  }
`;

// const StyledAvatar = styled(BigAvatar)`
//   margin: 0 auto;
//   // img {
//   //   filter: contrast(1.25);
//   //   mix-blend-mode: luminosity;
//   // }
// `;

ProfileCardWithUploadSupport.propTypes = {
  onUpload: PropTypes.func.isRequired,
  onUploadSuccess: PropTypes.func.isRequired,
};

export const ProfileCardWithUpload = withRouter(ProfileCardWithUploadSupport);
